import { LitElement, html, svg } from 'lit';

export class IconTriangle32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Varseltrekant</title><path stroke="currentColor" stroke-width="1.5" d="M1.045 28.845 14.21 1.7c.54-1.113 2.117-1.131 2.684-.032l13.978 27.145A1.5 1.5 0 0 1 29.54 31H2.394a1.5 1.5 0 0 1-1.35-2.155Z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 11.667V21.5M16 26v1"></path></svg>`; }
}
if (!customElements.get('f-icon-triangle32', IconTriangle32)) {
  customElements.define('f-icon-triangle32', IconTriangle32);
}